import * as fromSearch from '../actions/search.action';
import { ISearchState } from '@app/shared/model/interfaces/store/search-state';

const defaultSearchState: ISearchState = {
  isCurrent: false,
  searchValue: '',
  lastSearches: []
};

export function reducer(state: ISearchState = defaultSearchState, action: fromSearch.SearchActions) {
  switch (action.type) {
    case fromSearch.SET_SEARCH_VALUE:
      return { ...state, searchValue: action.payload };
    case fromSearch.SET_IS_SEARCH_IN_PROGRESS:
      return { ...state, isCurrent: action.payload };
    case fromSearch.ADD_CURRENT_SEARCH_TO_LAST_SEARCHES:
      const newSearches = state.lastSearches.filter(val => val['query'] !== action.payload['query']);
      return {
        ...state,
        lastSearches: [action.payload, ...newSearches]
      };
    case fromSearch.SET_CURRENT_SEARCH:
      return { ...state, currentSearch: action.payload };
    default:
      return state;
  }
}
